<template>
  <v-card-text class="px-4 pt-0">
    <p class="my-3">
      <strong
        >This popup message is to inform you of the following new privacy
        rules.</strong
      >
    </p>
    <p class="termsP">
      When using StokerCloud, you agree to the following conditions
    </p>
    <ul class="termsUl">
      <li>
        Use Stokercloud at your own risk and responsibility. StokerCloud makes
        it possible to adjust parameters online; which has an effect on the
        function of the pellet burner. Therefore ALWAYS be sure to be in the
        same location as the pellet burner when making adjustments. Never make
        changes to the burner when you are not physically present to monitor the
        effects.
      </li>
      <li>
        We emphasize that alarm cancellation must not be performed unless you
        are completely aware of why the alarm has occurred and are able to
        subsequently monitor the system in person.
      </li>
      <li>
        Stokersoft / NBE cannot be held responsible for any consequential
        effects due to incorrect values, which are either intentionally or
        unintentionally possible due to errors and/or due to other errors in
        StokerCloud's software.
      </li>
      <li>
        If you are unsure about any setting changes performed in StokerCloud you
        should use the pellet burner's physical controller to make adjustments,
        and only use StokerCloud for monitoring purposes.
      </li>
      <li>
        The StokerCloud service is an online service and may be prone to
        failure. Any service failures will be fixed as soon as possible.
        Stokersoft / NBE cannot be held liable for any loss due to missing
        connection, no text messages, emails etc.
      </li>
      <li>
        Any form of hacking, including the simple acquisition of other users'
        passwords, entails police report and permanent exclusion from the
        service.
      </li>
      <li>
        We use cookies and the page will not function without your acceptance.
      </li>
      <li>Regarding the protection of your personal information</li>
      <li>
        <ul>
          <li>
            - To have an account, you will need to register your email, name and
            address. When using this service, stokercloud will log your IP
            addresses on the connected pellet burner controller and used
            devices.
          </li>
          <li>
            - The information gathered is only to be used in a product support
            context.
          </li>
          <li>
            - At stokercloud.dk you can login to your account and see all
            registered information. Alternatively, you can send an email to
            support@nbe.dk with the heading "Send information for XXXXXX" where
            XXXXXX is the serial number on the controler
          </li>
          <li>
            - Your account can be closed by sending an email to support@nbe.dk
            with the headline Close account for (XXXXXX) where XXXXXX is the
            serial number on the control. Upon closing, all information on the
            account will be immediately deleted
          </li>
          <li>
            - When creating an account, you agree that we can contact you via
            email, phone, or by letter for related service and support - not in
            connection with sales activities.
          </li>
          <li>- No information is disclosed or sold to third parties</li>
        </ul>
      </li>
    </ul>
  </v-card-text>
</template>
<script>
export default {
  name: "TermsUK"
};
</script>
